import { z } from "zod";

export const updateWarehouseSchema = z.object({
  codebookFiles: z.array(z.string()).optional(),
  width: z.string(),
  height: z.string(),
  thickness: z.string().optional(),
  price: z.string(),
  quantity: z.string(),
  location: z.string(),
});

export type UpdateWarehouse = z.infer<typeof updateWarehouseSchema>;
